import { instance2 } from "App/constants";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { LIST_URL_MASTER } from "utils/masters";

export const RESET_STATE_PERUSAHAAN = {
  id: "",
  name: "",
  business: "",
  address: "-",
  phone: "-",
  contactperson: "-",
  cpaddress: "-",
  cpemail: "-",
  cpphone: "-",
  cpmobilephone: "-",
  status: 1,
  remark: "-",
  nama_virtual_account: "",
  no_virtual_account: "",
  nama_bank: "",
};

export const STYLE_TAB_PERUSAHAAN = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const getAllCompany = async () => {
  try {
    const api = await instance2.get(LIST_URL_MASTER.perusahaan.list);
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const deleteCompanyById = async (
  id,
  run,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance2.post(
      LIST_URL_MASTER.perusahaan.delete,
      {},
      {
        headers: {
          idcompany: id,
        },
      }
    );
    run(!run);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_PERUSAHAAN);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA PERUSAHAAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nama_bank",
    disablePadding: false,
    label: "BANK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "no_virtual_account",
    disablePadding: false,
    label: "NO. VIRTUAL ACCOUNT",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nama_virtual_account",
    disablePadding: false,
    label: "NAMA VIRTUAL ACCOUNT",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "address",
    disablePadding: false,
    label: "ALAMAT",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "phone",
    disablePadding: false,
    label: "NO TELEPON",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "contactperson",
    disablePadding: false,
    label: "NAMA KP",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "cpphone",
    disablePadding: false,
    label: "NO. TELEPON KP",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];
